
import Dispatch from '../Dispatcher'
import _ from 'lodash'

import { map, filter, share, switchMap, mergeMap, catchError, startWith, debounceTime, delay, tap, scan, concatMap, take, takeUntil, withLatestFrom } from 'rxjs/operators'
import { from, of, combineLatest, timer, merge, EMPTY, animationFrames } from 'rxjs'

import moment from 'moment'
//import { elapsedTime } from './clock';
// import { startScript } from './scripts'

import songs from '../songs'

import clock from './clock'

const defaultSong = 'https://s3.amazonaws.com/www.easttroylights.com/media/Carol+of+the+Bells.m4a'
// animationFrames()
// .subscribe(e => console.log(e))

var audio


// Dispatch.getState('MultiSelect.song')
Dispatch.getAction('loadSong')
  .subscribe(e => {localStorage.setItem('song', e)})

Dispatch.getAction('loadSong')
  .pipe(
    tap(e => Dispatch.nextAction('pause')),
//     // Filter mutliselect keys for true
//     map(multiSongs => _.filter(Object.keys(multiSongs).map(key => ({key, value: multiSongs[key]})), song => song.value)),
//     //map(multiSongs => _.find(multiSongs, song => song)),
//     tap(e => console.log("hiiiiii")),
// tap(e => console.log(e)),
//     map(filteredSongs => filteredSongs[0]),
//     tap(e => console.log("hooooooooooo")),
// // tap(e => console.log(e)),
    startWith(localStorage.getItem('song') ?? defaultSong)
  )
  .subscribe(song => {
    audio && audio.pause()
    //var audio = new Audio('https://s3.amazonaws.com/www.easttroylights.com/scripts/testsong.m4a');
    audio = new Audio(song);
    audio.addEventListener('canplaythrough', () => {
      Dispatch.nextState('view.songLength', audio.duration * 1000)
      Dispatch.nextState('audio.loaded', true)
    });
    audio.load()

    //audio.playbackRate = .5
    Dispatch.nextState('audio.song', audio)
  })

Dispatch.getState('view.speed')
  .subscribe(e => audio.playbackRate = e)
  // combineLatest(Dispatch.getState('view.playing'),
  //   Dispatch.getAction('scrubClock').pipe(startWith(0))
  // )
  //   .pipe(
  //     filter(e => e[0]),
  //     map(e => moment()),
  //     mergeMap(e => Dispatch.getState('audio.song')
  //       .pipe(
  //         switchMap(song => Dispatch.getState('audio.loaded').pipe(
  //             filter(e => e === true),
  //             take(1)
  //           )
  //           .pipe(
  //             withLatestFrom(Dispatch.getState('view.elapsed'), Dispatch.getState('audio.song')),
  //             tap(([,startTime, audio]) => {
  //               audio.currentTime = startTime/1000
  //               audio.play()
  //             }),
  //           )
  //         ),
  //       )
  //     )
  //   )
  //   .subscribe()


  merge(Dispatch.getAction('pause'))
  .pipe(
    withLatestFrom(clock)
  )
  .subscribe(e => {
    audio && audio.pause()
    Dispatch.nextState('view.elapsed', e[1])
    Dispatch.nextAction('pauseClock')
  })


  Dispatch.getAction('scrub')
  .pipe(
    withLatestFrom(Dispatch.getState('view.scale')),
    map(e => (e[0] / e[1].windowWidth) * e[1].songLength),
  )
  .subscribe(e => {
    console.log(e)
    Dispatch.nextState('view.elapsed', e)
    Dispatch.nextAction('scrubClock')
  })
  // Dispatch.getAction('start')
  //   .pipe(
  //     switchMap(e => clock
  //       .pipe(
  //         debounceTime(500)
  //       )
  //     )
  //   )
  //   .subscribe(e => Dispatch.nextState('view.elapsed', e))